import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { NotificationToast } from '@core/services/notification/notification';
import { PlatformService } from '@core/services/platform.service';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { SafePipe } from '@shared/safe/safe.pipe';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NgClass, NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgIf, NgFor, SvgIconComponent, SafePipe, TranslateSafePipe]
})
export class NotificationComponent implements OnInit, OnChanges {
    private timeoutId = 0;

    // Although this exist on data object, we keep it as separate input, otherwise ngOnChanges does not trigger
    @Input()
    initiateClose = false;

    @Input()
    data: NotificationToast;

    @Output() closeNotification = new EventEmitter<void>();

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly platformService: PlatformService,
        private readonly ngZone: NgZone
    ) {}

    ngOnInit(): void {
        if (this.platformService.isServer) {
            this.close();
            return;
        }

        this.ngZone.runOutsideAngular(() => {
            if (this.data.fadeTime > 0) {
                this.timeoutId = window.setTimeout(() => {
                    this.ngZone.run(() => {
                        this.initiateClose = true;
                        this.cd.markForCheck();
                    });
                }, this.data.fadeTime);
            }
        });
    }

    public handleClick(e: MouseEvent): void {
        e.stopPropagation();

        this.ngZone.runOutsideAngular(() => {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
            }
        });

        this.initiateClose = true;
    }

    // When this.initiateClose is true, transition will happen on element,
    // which will be caught by this listener on animationend
    public onAnimationend(): void {
        if (this.initiateClose) {
            this.close();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.platformService.isServer) {
            this.close();
            return;
        }
        // Failsafe if the animationend listener fails
        if (changes.initiateClose.currentValue === true) {
            this.ngZone.runOutsideAngular(() => {
                window.setTimeout(() => {
                    this.ngZone.run(() => {
                        this.close();
                    });
                }, 1000);
            });
        }
    }

    private close(): void {
        this.closeNotification.emit();
    }
}
